import React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
// import { AsyncPaginate } from "react-select-async-paginate";
import Loading from "../../components/LoadingTable";

import S3Uploader from "../components/S3Uploader";

// FIXME
// The buttons for
// adding +1
// adding +10
// adding +100
// rows are flaky

//TODO
// merge with TableSubmitMerged
export class TableSubmit extends React.Component {
  constructor(props) {
    super(props);
    this.refsCollection = {};
  }
  
  /*Get JSX Element For Reporting Errors*/
  getJSXerror = (row) =>
    row.error !== "" ? (
      <i id={`error_form_${row.id}-${row.index}`}>
        <font color="red"> {row.error} </font>
      </i>
    ) : null;

  /*Get Select Options JSX Object*/
  getJSXSelectOptions = (header, row) =>
    header.selection.map((optionItem) =>
      optionItem === row.value ? (
        <option value={optionItem} selected>
          {optionItem}
        </option>
      ) : (
        <option value={optionItem}>{optionItem}</option>
      )
    );

  /*Get Multiple Options JSX Object*/
  getJSXMultipleOptions = (header) =>
    header.selection.map((optionItem) => {
      return <option value={optionItem}> {optionItem} </option>;
    });

  /*Get Headers according to View Fields Configurations*/
  getHeaders = (headers, copyReason) => {
    //1. LogoutButton Format [ { id:"ID", title : "myTitle", inputType:"text | select | selectMultiple | number" , description:"", mandatory:true, selection:[...]} ]
    const columns = [];
    for (let header of headers) {
      //1.0 Generate LogoutButton
      const headerTable = { accessor: header.id };
      //1.1 Title Content
      const checkboxItem = "";

      //1.2 Tooltip LogoutButton
      headerTable.Header =
        "mandatory" in header || "description" in header
          ? (props) => (
              <div>
                {" "}
                {checkboxItem} {header.title}{" "}
                {header.mandatory ? <font color="red"> * </font> : null}
                {header.description !== "" ? (
                  <label title={header.description}>
                    {" "}
                    <i className="fa fa-comment-o" aria-hidden="true" />
                  </label>
                ) : null}{" "}
              </div>
            )
          : header.title;
      headerTable.style = { whiteSpace: "unset" };
      headerTable["minWidth"] = 100;
      columns.push(headerTable);
    }
    return columns;
  };

  //onChange is the changeHandler in Submission;
  getInputCellContents = (fieldHeader, fieldObject, onChange) => {
    //Return JSX Object according to the input type
    switch (fieldHeader.inputType) {
      case "text":
        return (
          <div>
            {" "}
            <input
              type="text"
              name={`${fieldObject.id}-${fieldObject.index}`}
              value={fieldObject.value}
              onChange={onChange}
              style={{ minWidth: "20px" }}
            />
            {this.getJSXerror(fieldObject)}{" "}
          </div>
        );
      case "select":
        return (
          <div>
            {" "}
            <select
              name={`${fieldObject.id}-${fieldObject.index}`}
              value={fieldObject.value}
              onChange={onChange}
              style={{ minWidth: "60px" }}
            >
              {this.getJSXSelectOptions(fieldHeader, fieldObject)}{" "}
            </select>{" "}
            {this.getJSXerror(fieldObject)}{" "}
          </div>
        );
      case "file":
        const info = `${fieldObject.id}-${fieldObject.index}`;
        return (
          <div>
            {" "}
            <S3Uploader
              // enable the individual trigger of the function startUpload() in <ReactS3UploaderCustomFunctional>
              ref={(instance) => {
                this.refsCollection[info] = instance;
              }}
              rowId={fieldObject.index}
              onChange={this.props.changeHandlerFiles}
              handleUploadedFilesChanged={this.props.handleUploadedFilesChanged}
            />
            {this.getJSXerror(fieldObject)}{" "}
          </div>
        );
    }
  };

  /*Get Data for React Table*/
  getData = (headers, data, onChange) => {
    //1.Headers [ { id:"ID", title : "myTitle", inputType:"text | select | selectMultiple | number" , description:"", mandatory:true, selection:[...]} ]
    //2.Data  [{id:"ID", value:'VALUE'},...,{id:"ID", value:'VALUE'}] ,..., [{id:"ID", value:'VALUE'},...,{id:"ID", value:'VALUE'}]
    const dataTable = [];
    
    

    // modify headers to change the preselection for the disease column

    for (let row of data) {
      const dataRow = {};
      for (let field of row) {
        const fieldHeader = headers.find((header) => header.id === field.id);
        dataRow[field.id] = this.getInputCellContents(
          fieldHeader,
          field,
          onChange
        );
      }
      dataTable.push(dataRow);
    }
    return dataTable;
  };

  /*Render Data*/
  render() {
    const columns = this.getHeaders(
      this.props.headers,
      this.props.embargoHandler,
      this.props.copyReason
    );
    const data = this.getData(
      this.props.headers,
      this.props.contents,
      this.props.changeHandler
    );
    /*Rendered JSX Components*/
    return (
      <ReactTable
        data={data}
        columns={columns}
        minRows={0}
        pageSizeOptions={[50, 100, 200, 500]}
        defaultPageSize={100}
        sortable={false}
        loading={this.props.loading}
        LoadingComponent={Loading}
        className="-striped -highlight"
        style={{
          height: 700,
        }}
      />
    );
  }
}
